import validatorResult from '@/directives/validator/common/result/validatorResult';

const regex = /[+\d][\d- ]{5,}/;
export default ({ severity = 'danger', required = true } = {}) => (value) => {
  const isValid = (!required && !value) || regex.test(value);
  return validatorResult(
    isValid,
    {
      danger: 'Ogiltigt telefonnummer',
      warn: 'Ett giltigt telefonnummer bör anges',
    },
    severity,
  );
};
